/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/date_diff.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Subtracts the `startTimestamp` from the `endTimestamp` and returns the difference in multiples of `unit`.\nIf `startTimestamp` is later than the `endTimestamp`, negative values are returned.',
  examples: [
    'ROW date1 = TO_DATETIME("2023-12-02T11:00:00.000Z"),\n    date2 = TO_DATETIME("2023-12-02T11:00:00.001Z")\n| EVAL dd_ms = DATE_DIFF("microseconds", date1, date2)',
    'ROW end_23 = TO_DATETIME("2023-12-31T23:59:59.999Z"),\n  start_24 = TO_DATETIME("2024-01-01T00:00:00.000Z"),\n    end_24 = TO_DATETIME("2024-12-31T23:59:59.999")\n| EVAL end23_to_start24 = DATE_DIFF("year", end_23, start_24)\n| EVAL end23_to_end24   = DATE_DIFF("year", end_23, end_24)\n| EVAL start_to_end_24  = DATE_DIFF("year", start_24, end_24)',
  ],
  params: {
    unit: 'Time difference unit',
    startTimestamp: 'A string representing a start timestamp',
    endTimestamp: 'A string representing an end timestamp',
  },
};

export default docs;
